import Vue from 'vue'

import '@babel/polyfill'
import 'mutationobserver-shim'
import InfiniteLoading from 'vue-infinite-loading'
import _ from 'lodash'

import 'vue-select/dist/vue-select.css'
import 'vue-select/src/scss/vue-select.scss'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import 'vue2-datepicker/index.css'

import './Utils/fliter'
import './config/firebase'
import './plugins'
import './registerServiceWorker'
import './directives'
import './Helpers/permisiionHelper'
import './Helpers/dateHelper'
import authPermissions from './mixins/auth-permission'
import datePermissions from './mixins/mainFunctionDate'

Object.defineProperty(Vue.prototype, '$_', { value: _ })
Vue.use(InfiniteLoading, {  })
Vue.mixin(authPermissions)
Vue.mixin(datePermissions)
